export const ENTER_PLAN_MODE_TOOL_NAME = 'EnterPlanMode'
